import { TeamMember } from "../types/TeamModel";
import api from "./api";

const ENTITY_PATH = "team-members";

export const getTeamMembers = async () => {
  try {
    const response = await api.get("/team-members");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch team members", error);
    throw error;
  }
};

export const createTeamMember = async (teamMember: TeamMember) => {
  try {
    const response = await api.post(ENTITY_PATH, teamMember, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error creating team member:", error);

    throw error;
  }
};

export const updateTeamMember = async (id: string, data: TeamMember) => {
  try {
    const response = await api.put(`${ENTITY_PATH}/${id}`, data);
    return response.data;
  } catch (error) {
    console.error("Error updating team member:", error);
    throw error;
  }
};

export const sendInviteEmail = async (teamMember: TeamMember) => {
  try {
    const response = await api.post(`team-members/invite`, teamMember);
    return response;
  } catch (error) {
    console.error("Error inviting team member:", error);
    throw error;
  }
};

export const deleteTeamMember = async (id: string) => {
  try {
    const response = await api.delete(`team-members/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting team member:", error);
    throw error;
  }
};
